import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  giveFeedbackButton: {
    id: 'frontbucket.navigationFeedbackCollector.giveFeedbackButton',
    description: 'Text for button to open feedback modal',
    defaultMessage: 'Give feedback',
  },
  giveFeedbackPlaceholder: {
    id: 'frontbucket.navigationFeedbackCollector.giveFeedbackButtonPlaceholder',
    description: 'Text for placeholder in give feedback modal',
    defaultMessage: "Let us know what's on your mind",
  },
  giveFeedbackTitleDetailsOne: {
    id: 'frontbucket.navigationFeedbackCollector.giveFeedbackTitleDetailsOneApp',
    description: 'Text for title details in give feedback modal',
    defaultMessage: 'Your thoughts help us improve Atlassian apps',
  },
  giveFeedbackTitleDetailsTwo: {
    id: 'frontbucket.navigationFeedbackCollector.giveFeedbackTitleDetailsTwo',
    description:
      'Text for title details in give feedback modal. The "support site" link text is wrapped in <link> tags.',
    defaultMessage:
      "If you''re looking to get help or want to report a bug, visit our <link>support site.</link>",
  },
  canContactLabel: {
    id: 'frontbucket.navigationFeedbackCollector.canContactLabel',
    description:
      'Text for the contact label. The "privacy policy" link text is wrapped in <link> tags.',
    defaultMessage:
      'Atlassian can contact me about this feedback. See our <link>privacy policy</link>',
  },
  enrolLabel: {
    id: 'frontbucket.navigationFeedbackCollector.enrolLabelApps',
    description:
      'Text for the enrol label. The "Atlassian Research Group" link text is wrapped in <link> tags.',
    defaultMessage:
      "I''d like to help improve Atlassian apps by joining the <link>Atlassian Research Group</link>",
  },
});
